// IndexedDB helper for Looper Sessions
const DB_NAME = 'fretflow_looper';
const DB_VERSION = 1;
const SESSIONS_STORE = 'sessions';

const openDB = () =>
  new Promise((resolve, reject) => {
    if (!window.indexedDB) return reject(new Error('IndexedDB non disponibile'));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(new Error('Impossibile aprire il database locale'));
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(SESSIONS_STORE)) {
        db.createObjectStore(SESSIONS_STORE, { keyPath: 'id' });
      }
    };
  });

const tx = (db, store, mode) => db.transaction(store, mode).objectStore(store);

export const getAllSessions = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = tx(db, SESSIONS_STORE, 'readonly').getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
};

export const getSession = async (id) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = tx(db, SESSIONS_STORE, 'readonly').get(id);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
};

export const saveSession = async (session) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(SESSIONS_STORE, 'readwrite');
    t.objectStore(SESSIONS_STORE).put(session);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};

export const deleteSession = async (id) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(SESSIONS_STORE, 'readwrite');
    t.objectStore(SESSIONS_STORE).delete(id);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};

export const countSessions = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = tx(db, SESSIONS_STORE, 'readonly').count();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
};
